module.exports = __webpack_public_path__ + "static/sport/right.178c14b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lottery/right.png
// module id = h4fb
// module chunks = 0